<div class="row">
  <div class="col-md-6">
    <h3 class="title-page text-primary">Danh sách đăng ký kiểm hóa</h3>
    Dữ liệu mới nhất lúc: {{today | date:'dd-MM-yyyy HH:mm:ss'}}
  </div>
  <div class="col-md-6" style="text-align: right; margin-top: 15px;">
    <button style="margin-right: 5px;" type="button" [disabled]="isDeleteMulti"
      class="btn btn-primary" data-toggle="modal" data-target="#mdFeedbackMulti">
      Phản hồi
    </button>
    <button style="margin-right: 5px;" (click)="deleteMulti()" [disabled]="isDeleteMulti"
      class="btn btn-primary">Xóa</button>
    <button style="margin-right: 5px;" (click)="loadRegistrationVerify()" class="btn btn-primary">Lấy dữ liệu mới
      nhất</button>
    <button (click)="exportExcel()" class="btn btn-primary">Xuất file Excel</button>
    <!-- <button (click)="deleteOldData()" class="btn btn-primary">Xóa bản ghi cũ</button> -->
  </div>
</div>
<div style="float: right;">
  <pagination-controls id="paging" (pageChange)="onChangePage($event)" (pageBoundsCorrection)="onChangePage($event)"
    maxSize="20" directionLinks="true" responsive="true" previousLabel="Trước" nextLabel="Sau"
    screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page">
  </pagination-controls>
</div>
<table class="table table-bordered table-striped">
  <thead>
    <th scope="col" style="text-align: center;"> </th>
    <th scope="col" style="text-align: center;">STT</th>
    <th scope="col" style="text-align: center;">Số tờ khai</th>
    <th scope="col">Ngày xuất trình hàng</th>
    <th scope="col">Giờ xuất trình hàng</th>
    <th scope="col">Mã loại hình</th>
    <th scope="col">Tên doanh nghiệp</th>
    <th scope="col">Tên hàng</th>
    <th scope="col">Số lượng</th>
    <th scope="col">Địa điểm</th>
    <th scope="col">Tên người xuất trình HH </th>
    <th scope="col">Sđt người xuất trình HH</th>
    <th scope="col">Kiểm hóa viên</th>
    <th scope="col">Phản hồi</th>
    <th scope="col">Thời gian tạo</th>
    <th scope="col"></th>
  </thead>
  <tbody>
    <tr
      *ngFor="let registrationVerify of registrationVerifies | paginate: { id: 'paging', itemsPerPage: pageSize, currentPage: page, totalItems: count }; let i = index ">
      <td> <input checkOne type="checkbox" (change)="checkedItem()" [name]="registrationVerify.id"
          [id]="registrationVerify.id" [(ngModel)]="registrationVerify.checked"></td>
      <td style="text-align: center;">{{i + 1}}</td>
      <td style="text-align: left;"><a (click)="viewDetails(registrationVerify.id)"
          class="nav-link">{{registrationVerify.declarationNumber}}</a></td>
      <td>{{registrationVerify.expectedDeliveryDate}}</td>
      <td>{{registrationVerify.expectedDeliveryHour}}</td>
      <td>{{registrationVerify.codeType}}</td>
      <td>{{registrationVerify.enterpriseName}}</td>
      <td>{{registrationVerify.productName}}</td>
      <td>{{registrationVerify.countProduct}}</td>
      <td>{{registrationVerify.address}}</td>
      <td>{{registrationVerify.receiverName}}</td>
      <td>{{registrationVerify.receiverPhone}}</td>
      <td>{{registrationVerify.verifyName}}</td>
      <td>{{registrationVerify.feedbackInformation}}</td>
      <td>{{registrationVerify.createdDate | date:'dd-MM-yyyy HH:mm:ss'}}</td>
      <td class="text-center"><a (click)="delete(registrationVerify.id, registrationVerify.declarationNumber)"><i
            class="fa fa-trash-o" aria-hidden="true"></i></a></td>
    </tr>
  </tbody>
</table>
<div style="float: right;">
  <pagination-controls id="paging" (pageChange)="onChangePage($event)" (pageBoundsCorrection)="onChangePage($event)"
    maxSize="20" directionLinks="true" responsive="true" previousLabel="Trước" nextLabel="Sau"
    screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page">
  </pagination-controls>
</div>
<!-- The Modal -->
<div class="modal" id="mdFeedbackMulti">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Phản hồi</h4>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label" for="verifyName">Người kiểm tra</label>
          <input class="form-control" id="verifyName" required [(ngModel)]="registrationVerifyMulti.verifyName"
            name="verifyName" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="feedbackInformation">Thông tin</label>
          <input class="form-control" id="feedbackInformation" required
            [(ngModel)]="registrationVerifyMulti.feedbackInformation" name="feedbackInformation" />
        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="replyMulti()" data-dismiss="modal">Gửi phản hồi</button>
        <button type="button" class="btn btn-danger" (click)="closeModal()" data-dismiss="modal">Đóng lại</button>
      </div>

    </div>
  </div>
</div>
